<div class="container-fluid "  >
  <div class="row   ">
    <div class="col-6 col-md-12 w-100 ">
<input class="variation" id="bluepurple" type="radio" value="1" name="color" checked="checked" />
 

 
<main class="mt-0">
    <section>
        <div class="profile profile-imgonly">
            <div class="profile__image"><img src="https://www.dreamjob.ma/wp-content/uploads/2019/11/STG-Maroc-Emploi-Recrutement-Dreamjob.ma-1-600x315.png" alt="Doggo" /></div>



        </div>
    </section>
    <section>
        <div class="profile profile-default">
            <div class="profile__image"><img src="https://lh3.googleusercontent.com/986QNspt3XOoolNLKbaVgWSjvjzEza9MfA7gI64Bj6lt8X-w5PRyyJ63pcZUAd0Luno" alt="Doggo" /></div>
            <div class="profile__info">
                <h3>{{ 'PREFERENCE.LOCAL.TITLE' | translate }}</h3>


<div     id="countries_states2"   class="bfh-selectbox bfh-countries" data-country="" data-flags="true">

</div>

<div id="state"   class="bfh-selectbox bfh-states" data-state=""     data-country="countries_states2">
</div>

<div id="langue" class="bfh-selectbox bfh-languages" data-language="" data-available="en_US,fr_FR,es_ES" data-flags="true">
</div>




<!--
<div   class="form-group bfh-selectbox bfh-countries" data-country="US" data-flags="true">
    <input type="hidden" #input id='country' value="">
    <a class="bfh-selectbox-toggle" role="button" data-toggle="bfh-selectbox" href="#">
        <span class="bfh-selectbox-option input-medium" data-option=""></span>
        <b class="caret"></b>
    </a>
    <div class="bfh-selectbox-options">
        <div role="listbox">
            <ul role="option"></ul>
        </div>
    </div>
</div>
-->
            </div>
            <div class="profile__stats">
                <p class="profile__stats__title">{{ 'PREFERENCE.LOCAL.LANGUE' | translate }}</p>
                <h5 class="profile__stats__info">{{test2}}</h5>
            </div>
            <div class="profile__stats">
                <p class="profile__stats__title">{{ 'PREFERENCE.LOCAL.ZONE' | translate }}</p>
                <h5>{{test}}</h5>
            </div>
            <div class="profile__stats">
                <p class="profile__stats__title">{{ 'PREFERENCE.LOCAL.STATE' | translate }}</p>
                <h5 class="profile__stats__info">{{test1}}</h5>
            </div>

            <div (click)="getvlue()" class="profile__cta"><a class="button">{{ 'PREFERENCE.SAVE' | translate }}</a></div>
        </div>
    </section>
    <section>
        <div class="profile profile-smallimg">
            <div class="profile__image"><img src="https://cdn.pixabay.com/photo/2019/07/02/05/54/tool-4311573_960_720.png" alt="Doggo" /></div>
            <div class="profile__info">
                <h3>{{ 'PREFERENCE.PARAMETER.TITLE' | translate }}</h3>

                <p class="profile__info__extra">{{ 'PREFERENCE.PARAMETER.SUBTITLE' | translate }}</p>
            </div>
            <div class="profile__stats">

           <div class="form-group">
            <select class="form-control" id="exampleFormControlSelect1">
              <option>{{ 'PREFERENCE.PARAMETER.OPTIONFIRST' | translate }}</option>
              <option>{{ 'PREFERENCE.PARAMETER.OPTIONSECOND' | translate }}</option>

            </select>
          </div>
            </div>

            <div class="profile__cta"><a class="button">{{ 'PREFERENCE.SAVE' | translate }}</a></div>
        </div>
    </section>
    <section>
        <div class="profile profile-table">
            <div class="profile__image"><img style="     width: 116%;" src="https://qodeinteractive.com/magazine/wp-content/uploads/2019/10/How-to-Easily-Customize-the-Date-and-Time-Format-in-WordPress.jpg" alt="Doggo" /></div>
            <div class="profile__info">
                <h3>{{ 'PREFERENCE.DATE.TITLE' | translate }}</h3>
          <div class="d-flex px-4 pt-0">
           <div  class="form-group px-3 pt-0">
  <p class="profile__stats__title">{{ 'PREFERENCE.DATE.DATE' | translate }}</p>
            <select  [(value)]="selected" class="form-control mr-5" id="exampleFormControlSelect1">

              <option value="option1">dd/MM/YYYY (ex: 16/09/2020)</option>
              <option>MM/dd/YYYY (ex: 09/16/2020)</option>

            </select>
          </div>




           <div class="form-group px-3 pt-0">
             <p class="profile__stats__title">{{ 'PREFERENCE.DATE.TEMPS' | translate }}</p>
            <select [(value)]="selected" class="form-control mr-5 pr-5" id="exampleFormControlSelect1">

              <option value="option1">HH:mm (ex: 11:14)</option>
              <option>h:mm a (ex: 11:14 AM)</option>

            </select>
          </div>
              </div>
            </div>


            <div  class="profile__cta"><a style="padding: 37px;" class="button">{{ 'PREFERENCE.SAVE' | translate }}</a></div>
        </div>
    </section>
    <section>
        <div class="profile profile-wide">
            <div class="profile__image"><img src="https://www.elegantthemes.com/blog/wp-content/uploads/2017/04/password-protect-wordpress.jpg" alt="Doggo" /></div>
            <div class="profile__info">
                <h3>{{ 'PREFERENCE.PASS.TITLE' | translate }}</h3>
               <div class="form-group">
                <p class="profile__stats__title">{{ 'PREFERENCE.PASS.PASSB' | translate }}</p>
              <input type="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="{{ 'PREFERENCE.PASS.PASSB' | translate }}">
            </div>



               <div class="form-group">
              <p class="profile__stats__title">{{ 'PREFERENCE.PASS.PASSN' | translate }}</p>
              <input type="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="{{ 'PREFERENCE.PASS.PASSN' | translate }}">
            </div>

             <div class="form-group">
              <p class="profile__stats__title">{{ 'PREFERENCE.PASS.PASSC' | translate }}</p>
              <input type="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="{{ 'PREFERENCE.PASS.PASSC' | translate }}">
            </div>
            </div>

            <div class="profile__cta"><a class="button">{{ 'PREFERENCE.SAVE' | translate }}</a></div>
        </div>
    </section>
    <section>
        <div class="profile profile-long">
            <div class="profile__image"><img src="https://hemiole72.files.wordpress.com/2018/04/logo-mail.png" alt="Doggo" /></div>
            <div class="profile__info">
                <h3>{{ 'PREFERENCE.EMAIL.TITLE' | translate }}</h3>
 <div class="row">
    <div class="col-6 col-md-2 w-100">
                  <img src="https://img.icons8.com/color/48/000000/info--v1.png"/>

    </div>
     <div class="col-6 col-md-10 w-100">
         <p class="profile__info__extra">
{{ 'PREFERENCE.EMAIL.HELP' | translate }}</p>
    <div class="form-group">
                <p class="profile__stats__title">{{ 'PREFERENCE.EMAIL.EMAIL' | translate }}</p>
              <input type="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="{{ 'PREFERENCE.EMAIL.EMAIL' | translate }}">
            </div>
                <div class="form-group">
                <p class="profile__stats__title">{{ 'PREFERENCE.EMAIL.EMAILC' | translate }}</p>
              <input type="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="{{ 'PREFERENCE.EMAIL.EMAILC' | translate }}">
            </div>
    </div>

    </div>
                       </div>
         <div class="profile__cta mr-2" ><a class="button">{{ 'PREFERENCE.SAVE' | translate }}</a></div>
            <div class="profile__cta"><a class="button">{{ 'PREFERENCE.RETOUR' | translate }}</a></div>
        </div>
    </section>

</main>

</div>

</div>

</div>

